import { render, staticRenderFns } from "./Retenciones.vue?vue&type=template&id=4b69d510&"
import script from "./Retenciones.vue?vue&type=script&lang=js&"
export * from "./Retenciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports